import { isValidPhoneNumber } from "libphonenumber-js"
import * as yup from "yup"

// The phone fields let members clear the country code and type their national number, which
// went out as another country's number ("+7…" for a Swedish "07…"). Twilio refused those and
// the login said "Something went wrong", so the number is checked before it's sent.
export const phoneNumberField = () =>
  yup
    .string()
    .required("Phone number is required")
    .test(
      "valid-phone-number",
      "Enter a valid phone number, with its country code",
      (value) => !value || isValidPhoneNumber(value),
    )
